self.fetch || (self.fetch = function (e, n) {
  return n = n || {}, new Promise(function (t, s) {
    var r = new XMLHttpRequest(),
        o = [],
        u = [],
        i = {},
        a = function a() {
      return {
        ok: 2 == (r.status / 100 | 0),
        statusText: r.statusText,
        status: r.status,
        url: r.responseURL,
        text: function text() {
          return Promise.resolve(r.responseText);
        },
        json: function json() {
          return Promise.resolve(r.responseText).then(JSON.parse);
        },
        blob: function blob() {
          return Promise.resolve(new Blob([r.response]));
        },
        clone: a,
        headers: {
          keys: function keys() {
            return o;
          },
          entries: function entries() {
            return u;
          },
          get: function get(e) {
            return i[e.toLowerCase()];
          },
          has: function has(e) {
            return e.toLowerCase() in i;
          }
        }
      };
    };

    for (var c in r.open(n.method || "get", e, !0), r.onload = function () {
      r.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (e, n, t) {
        o.push(n = n.toLowerCase()), u.push([n, t]), i[n] = i[n] ? i[n] + "," + t : t;
      }), t(a());
    }, r.onerror = s, r.withCredentials = "include" == n.credentials, n.headers) {
      r.setRequestHeader(c, n.headers[c]);
    }

    r.send(n.body || null);
  });
});